import Vue from "vue";
import SectorDetails from "./SectorDetails.vue";

export function load() {
  const selector = "SectorDetails-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(SectorDetails, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
